import React, { ImgHTMLAttributes, useState } from 'react';

export interface SmartImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** 
   * If true, disabled lazy loading, sets high fetchpriority.
   * Useful for LCP elements (hero banners).
   */
  isLcp?: boolean;
  /**
   * Explicit source.
   */
  src: string;
  /**
   * Optional manual srcset string
   */
  srcSet?: string;
  /**
   * Optional sizes string
   */
  sizes?: string;
  /**
   * Optional placeholder or fallback styling class
   */
  containerClassName?: string;
}

export const SmartImage: React.FC<SmartImageProps> = ({ 
  src, 
  srcSet,
  sizes,
  isLcp = false, 
  className = '', 
  containerClassName = '',
  alt = '',
  ...props 
}) => {
  const [error, setError] = useState(false);

  // Default image attributes
  const imgProps = {
    src,
    alt,
    className,
    loading: (isLcp ? "eager" : "lazy") as "eager" | "lazy",
    fetchPriority: (isLcp ? "high" : "auto") as "high" | "auto" | "low",
    srcSet,
    sizes,
    ...props
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setError(true);
    if (props.onError) {
      props.onError(e);
    }
  };

  return (
    <div className={containerClassName}>
      <img
        {...imgProps}
        onError={handleImageError}
      />
    </div>
  );
};

